import { ExlyDeleteModal as __ExlyDeleteModal } from "features/Common/modules/ExlyDeleteModal/ExlyDeleteModal";

/**
 *
 * @deprecated use from features/Common/modules/ExlyDeleteModal/ExlyDeleteModal.jsx
 *
 */
const ExlyDeleteModal = __ExlyDeleteModal;
export default ExlyDeleteModal;
